import React, { Fragment, useState, useEffect } from 'react';
import { Grid, makeStyles, withStyles, InputBase, CardHeader } from '@material-ui/core';
import { palette, useStylesGlobal } from 'configurations/styles/theme';
import tableStyle from 'configurations/styles/table'
import AssignmentIcon from '@material-ui/icons/Assignment';
import TableDataSimplePag from 'widgets/Tables/TableDataSimplePag';
import TableDataSimple from 'widgets/Tables/TableDataSimple';
import { useStylesApp } from 'hooks/useStyles';
import MultipleFiscalReference from '../Vouchers/invoices/Buttons/MultipleFiscalReference';
import DeleteInformationPaymentBtn from '../Vouchers/invoices/Buttons/DeleteInformationPaymentBtn';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    margin: theme.spacing(1),
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '1%',
    borderStyle: 'solid',
    boxShadow: "5px 3px 3px #aaaaaa",
    borderRadius: '8px',
    borderWidth: '2px'
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,

  },
  radio: {
    display: '-webkit-box',
    marginTop: '0px'
  },
  radioLable: {
    color: palette.primary.main,
    display: 'flex'
  },
  radioButton: {
    marginTop: '0px',
    paddingTop: '0px'
  },
  divForm: {
    marginBottom: '0%',
    textAlign: 'justify',
    color: theme.palette.text.primary,
  },
  divInput: {
    marginBottom: '1%',
    paddingRight: '1%',
    //paddingLeft: '0.5%',
    textAlign: 'justify',

  },
  divSelect: {
    width: '100%',
  },
  divButton: {
    paddingLeft: '3%',
    paddingRight: '3%'
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  haedClient: {
    backgroundColor: palette.primary.main,
    width: '10%',
    marginBottom: '2%',
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '1%',
    borderStyle: 'solid',
    borderBottomWidth: '5px',
    borderRadius: '8px',
  }
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    //position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

const MultipleReferenceDebitNote = ({ documentosFiscales, setDocumentosFiscales, iDoc }) => {
  const classes = useStyles();
  const classesGlobales = useStylesGlobal();
  const [documentoFiscal, setDocumentoFiscal] = useState({});
  const [viewPago, setViewPago] = useState(1);
  const columns = [
    { title: 'RUC del emisor', field: 'rucEmisor.ruc', cellStyle: tableStyle.cellTable, width: '30%' },
    { title: 'CUFE referenciado', field: 'cufeReferenciada', cellStyle: tableStyle.cellTable, width: '10%' },
    { title: 'nro. de factura en papel', field: 'nroFacturaPapel', cellStyle: tableStyle.cellTable, width: '10%' },
    { title: 'nro. de factura emitida por impresora fiscal ', field: 'nroFacturaImpresora', cellStyle: tableStyle.cellTable, width: '10%' },
    {
      title: 'Eliminar', cellStyle: tableStyle.cellTable, width: '10%', render: rowData => <DeleteInformationPaymentBtn
        data={rowData}
        pagos={documentosFiscales}
        setPagos={setDocumentosFiscales}
        viewPago={viewPago}
        setViewPago={setViewPago} />
    }
  ];
  const [update, setUpdate] = useState(1);
  const classesApp = useStylesApp();

  return (
    <Fragment>
      <div className={classesGlobales.itemContainer} >
        <Grid container xs={12} md={12}
          justify='center'        >
          <CardHeader
            className={classesGlobales.cabecera}
            title={'Datos del documento fiscal referenciado'}
            avatar={<AssignmentIcon></AssignmentIcon>}
          />
        </Grid>
        <Grid container spacing={1} className={classesGlobales.containerForm}>
          <Grid item xs={12} md={12}>
            <MultipleFiscalReference
              documentosFiscales={documentosFiscales}
              setDocumentosFiscales={setDocumentosFiscales}
              viewPago={viewPago}
              setViewPago={setViewPago}
              iDoc={iDoc}
            />
            {documentosFiscales.length > 0 ?
              <Grid item xs={12} md={12}>
                {viewPago === 1 ?

                  <TableDataSimplePag
                    title=""
                    columns={columns}
                    data={documentosFiscales}
                    buscar={false}
                  />
                  :
                  <TableDataSimple
                    title=""
                    columns={columns}
                    data={documentosFiscales}
                    buscar={false}
                  />
                }
              </Grid>
              :
              null
            }
          </Grid>
        </Grid>
      </div>

    </Fragment>
  );
}

export default MultipleReferenceDebitNote;